module.exports = __webpack_public_path__ + "static/media/credit-card.8821c843.svg";